import script from "./ContentEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentEditor.vue?vue&type=script&setup=true&lang=js"

import "./ContentEditor.vue?vue&type=style&index=0&id=2f159b55&lang=scss"

const __exports__ = script;

export default __exports__